import { StandardEvents } from '@shopify/events';

class PrimordialCollectionCard extends HTMLElement {
  #card;
  #data;
  #generation = 0;

  connectedCallback() {
    this.#card = this.closest('product-card');
    const source = this.querySelector('[data-card-variants]');
    if (!this.#card || !source) return;
    try {
      this.#data = JSON.parse(source.textContent);
    } catch {
      return;
    }
    this.#card.addEventListener(StandardEvents.productSelect, this.#handleSelect);
  }

  disconnectedCallback() {
    this.#generation++;
    this.#card?.removeEventListener(StandardEvents.productSelect, this.#handleSelect);
  }

  #handleSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') !== this.#card) return;
    const generation = ++this.#generation;
    const requestedId = event.detail?.variantId;
    Promise.resolve(event.promise)
      .then((result) => {
        if (!this.isConnected || generation !== this.#generation) return;
        const resolvedId = result?.detail?.resource?.id ?? result?.variant?.id ?? requestedId;
        const variant = this.#data.variants.find((item) => String(item.id) === String(resolvedId));
        if (!variant) return;
        const caption = this.querySelector('[data-card-caption]');
        if (caption) {
          caption.textContent = variant.caption;
          caption.hidden = !variant.caption;
        }
        const prices = this.querySelector('.primordial-card__prices');
        prices.dataset.onSale = String(variant.onSale);
        this.querySelector('[data-card-current] bdi').textContent = variant.price;
        this.querySelector('[data-card-price-label]').textContent = variant.onSale ? this.#data.saleLabel : this.#data.regularLabel;
        const compare = this.querySelector('[data-card-compare]');
        compare.querySelector('bdi').textContent = variant.compare;
        compare.hidden = !variant.onSale || prices.dataset.showCompare !== 'true';
        const saleLabel = this.querySelector('[data-card-sale-label]');
        if (saleLabel) saleLabel.hidden = !variant.onSale;
        const unit = this.querySelector('[data-card-unit-price]');
        const unitDocument = new DOMParser().parseFromString(variant.unitHtml || '', 'text/html');
        unit.replaceChildren(...unitDocument.body.childNodes);
      })
      .catch(() => {});
  };
}

if (!customElements.get('primordial-collection-card')) {
  customElements.define('primordial-collection-card', PrimordialCollectionCard);
}
